/* jshint esversion: 6 */

/*
 * PostHog `before_send` hook that drops `$exception` events whose stack never
 * touches our bundles. Code injected into the page at runtime — browser
 * extensions, mostly — reports the page URL as its filename, so PostHog files
 * it as in-app and it lands in error tracking looking like ours.
 *
 * Every webpack chunk, vendor splits included, loads from the public path, so a
 * frame under it is ours. The build emits a protocol-relative path, hence the
 * resolve against the page. A stack with no filenames at all (a cross-origin
 * "Script error.", say) says nothing about where it came from, so it is kept.
 */
export function dropForeignExceptions(event) {
    if (event?.event !== '$exception') {
        return event;
    }

    const exceptions = event.properties?.$exception_list;
    if (!Array.isArray(exceptions)) {
        return event;
    }

    const filenames = exceptions
        .flatMap((exception) => exception?.stacktrace?.frames ?? [])
        .map((frame) => frame?.filename)
        .filter((filename) => typeof filename === 'string' && filename !== '');

    if (filenames.length === 0) {
        return event;
    }

    const bundlePrefix = new URL(__webpack_public_path__, window.location.href).href;

    return filenames.some((filename) => filename.startsWith(bundlePrefix)) ? event : null;
}
